module.exports = __webpack_public_path__ + "static/media/pt-degustation.b771966d.svg";